import { devtools } from "zustand/middleware";

import { create } from "./helpers/resetStore.helper";

interface LocationDashboardState {
  locationLevel: number | undefined;
  currentLocationId: string | undefined;
  setLocationLevel: (id: number | undefined) => void;
  setCurrentLocationId: (id: string) => void;
  reset: () => void;
}

const useLocationDashboardStore = create<LocationDashboardState>(
  devtools(
    (set) => ({
      locationLevel: undefined,
      currentLocationId: undefined,
      setLocationLevel: (id: number | undefined) => {
        set(() => ({ locationLevel: id }));
      },
      setCurrentLocationId: (locationId: string) => {
        set(() => ({ currentLocationId: locationId?.replace("dashboard", "").replace("files", "") }));
      },
      reset: () => {
        set({
          locationLevel: undefined,
          currentLocationId: undefined,
        });
      },
    }),
    {
      name: "location-dashboard-state",
    }
  )
);

export default useLocationDashboardStore;
